import dayjs from "dayjs";

export type DateRange = {
  from?: string;
  to?: string;
};

export function isEmptyDateRange({ from, to }: DateRange): boolean {
  return !from && !to;
}

export function matchesDateRange(
  dateTime: string | undefined,
  range: DateRange,
  timezone: string,
): boolean {
  if (isEmptyDateRange(range)) return true;
  if (!dateTime) return false;
  const day = dayjs(dateTime).tz(timezone).format("YYYY-MM-DD");
  const isAfterFrom = !range.from || day >= range.from;
  const isBeforeTo = !range.to || day <= range.to;
  return isAfterFrom && isBeforeTo;
}
